import {DraftCover} from "./DraftCover";
import {DraftBody} from "./DraftBody";
import {DataObject} from "./DataObject";
import {Project} from "./Project";

export class Draft implements DataObject {
  ID: number;
  work_ID: number = 0;
  org_ID: number;
  title: string = '';
  subtitle: string = '';
  author: string = '';
  comment: string = '';
  body_ID: number;
  cover_ID: number;
  lastUpdate: Date = new Date();
  locked_by_user_ID: number;
  bindingType: string = 'PERFECT';
  interiorType: string = 'GRAY';
  // ISO 639-3 (3-letter) language code for the work-in-progress
  // draft. Kept in sync with Book.languageCode / Product.languageCode
  // when a draft is promoted to a book or when book fields are
  // copied back onto a draft (see ProjectsComponent language combo
  // boxes and docs/contracts/outbox/2026-08-07-draft-language-code.md).
  languageCode: string = '';
  weight: number = 0;
  thickness: number = 0;
  draftBody: DraftBody;
  draftCover: DraftCover;
  project: Project;
  primaryInProject: Project;

  constructor( obj ) {
    this.primaryInProject = undefined;
    this.project = undefined;
    if ( obj && obj['ID']) {
      this.ID = obj['ID'];
    }
    this.update(obj);
  }

  getId () {
    return this.ID;
  }

  getOrderValue () {
    return this.ID;
  }

  update (obj: any) {
    if (obj) {
      for (const prop of Object.keys(obj)) {
        if (obj[prop] !== null && (prop !== 'ID') && ( typeof obj[prop] === 'string' || typeof obj[prop] === 'number' || typeof obj[prop] === 'boolean' || obj[prop] instanceof String || obj[prop] instanceof Boolean || obj[prop] instanceof Number || obj[prop] instanceof Date )) {
          this[prop] = obj[prop];
        }
      }
    }
  }

}
